module.exports = __webpack_public_path__ + "img/dws-icon.a4fb8c68.png";